import React from 'react'
import { MoonIcon, SunIcon } from './icons'
import { useKarteraTheme } from './KarteraThemeContext'

const options = [
    { value: 'light', label: 'Claro', Icon: SunIcon },
    { value: 'dark', label: 'Oscuro', Icon: MoonIcon },
]

const KarteraThemeSwitch = ({ className = '', compact = false, showLabels = false }) => {
    const { theme, setTheme } = useKarteraTheme()

    return (
        <div
            role="group"
            aria-label="Tema de la pantalla"
            className={`flex gap-0.5 rounded-xl border border-k-line p-[3px] ${compact ? 'bg-k-surface' : 'bg-k-bg'} ${className}`}
        >
            {options.map(({ value, label, Icon }) => {
                const active = theme === value
                return (
                    <button
                        key={value}
                        type="button"
                        aria-pressed={active}
                        aria-label={label}
                        onClick={() => setTheme(value)}
                        className={compact
                            ? `flex h-9 w-9 cursor-pointer items-center justify-center rounded-[9px] border-0 ${active ? 'bg-k-accent-soft text-k-accent-ink' : 'bg-transparent text-k-muted hover:text-k-ink'}`
                            : `flex min-h-9 cursor-pointer items-center gap-1.5 rounded-[9px] border-0 px-3 text-[13px] ${showLabels ? 'flex-1 justify-center' : ''} ${active
                                ? theme === 'light'
                                    ? 'bg-k-primary font-bold text-white shadow-k-seg'
                                    : 'bg-k-surface font-bold text-k-ink shadow-k-seg'
                                : 'bg-transparent font-semibold text-k-muted hover:text-k-ink'}`}
                    >
                        <Icon />
                        {!compact && <span className={showLabels ? 'inline' : 'hidden sm:inline'}>{label}</span>}
                    </button>
                )
            })}
        </div>
    )
}

export default KarteraThemeSwitch
